import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ec27d21a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ec27d21a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec27d21a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\project\\bigBee\\bigbee_backend_ui_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec27d21a')) {
      api.createRecord('ec27d21a', component.options)
    } else {
      api.reload('ec27d21a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ec27d21a&scoped=true", function () {
      api.rerender('ec27d21a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screen/components/HistogramPanel/index.vue"
export default component.exports